export type CompareKind = 'percent' | 'currency' | 'number';

// Maps a KPI `format` ("percentage:1", "currency:2", "number:0", "float:1") to the
// compareKind expected by renderMetricCell's absolute-delta formatter.
export const compareKindForFormat = (format?: string): CompareKind => {
  const f = (format ?? '').split(':')[0];
  if (f === 'percentage') return 'percent';
  if (f === 'currency') return 'currency';
  return 'number';
};
